import AuthLayout from './AuthLayout';
import { Form, Input, message } from 'antd';
import SubmitBtn from './SubmitBtn';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import useSignIn from '../../_hooks/useSignIn';
import { observer } from 'mobx-react-lite';

const ForgotPassword = observer(() => {
    const navigate = useNavigate();
    return (
        <div>
            <AuthLayout
                isBack={
                    <div
                        className="flex items-center gap-2 text-theme-icon-color mb-[10px] cursor-pointer"
                        onClick={() => navigate('/auth/login')}>
                        <IoArrowBack className="text-xl text-theme-icon-color" />
                        <span className="font-favorit font-[500] text-[14px]">
                            Back
                        </span>
                    </div>
                }
                title="Forgot password"
                subtitle="Please enter your registered email address. We’ll share a verification code."
                content={<ForgotPasswordForm />}
            />
        </div>
    );
});
export default ForgotPassword;

const ForgotPasswordForm = observer(() => {
    const [form] = Form.useForm();

    const navigate = useNavigate();

    const { resetPasswordOtp, isLoading } = useSignIn();

    const onFinish = (values) => {
        const { email } = values;
        resetPasswordOtp(email)
            .then((result) => {
                message.success('Verification code sent to your email');
                navigate('/auth/reset-password', {
                    state: { email: email },
                });
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    return (
        <>
            <Form
                form={form}
                name="login"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                autoComplete="off"
                className="auth-form-antd">
                {/* Email */}

                <Form.Item
                    name="email"
                    label="Email *"
                    className="mb-[16px]"
                    rules={[
                        {
                            required: true,

                            type: 'email',

                            message: 'Please enter a  email address!',
                        },
                    ]}>
                    <Input
                        placeholder="Enter your email address"
                        className="auth-form-antd-form-item"
                    />
                </Form.Item>

                <Form.Item className="mb-[16px]">
                    <SubmitBtn
                        label="Send verification code"
                        className="w-full"
                        isLoading={isLoading}
                    />
                </Form.Item>
            </Form>
        </>
    );
});
